"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Colors_1 = require("../../Colors");
const Button_1 = require("./Button");
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
const Paging = react_1.default.memo(({ defaultShowCount, showCount, page, totalCount, handlerMoreData }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    // 한 페이지에 표시할 페이지 수
    const pageSize = defaultShowCount ? defaultShowCount : isMobile ? 5 : 10;
    // 전체 페이지 수 계산
    const totalPages = (0, react_1.useMemo)(() => Math.ceil(totalCount / showCount), [totalCount, showCount]);
    // 현재 페이지 그룹의 첫 번째 페이지 번호
    const startPage = (0, react_1.useMemo)(() => Math.floor(page / pageSize) * pageSize, [page, pageSize]);
    const useGroupJump = totalPages > pageSize;
    const hasPrevPage = page > 0;
    const hasNextPage = page + 1 < totalPages;
    const hasPrevGroup = startPage > 0;
    const hasNextGroup = startPage + pageSize < totalPages;
    const canJumpFirst = hasPrevPage;
    const canJumpLast = hasNextPage;
    const firstJumpTarget = useGroupJump && hasPrevGroup ? startPage - pageSize : 0;
    const lastJumpTarget = useGroupJump && hasNextGroup ? startPage + pageSize : totalPages - 1;
    // 페이지 이동 핸들러
    const handlePageChange = (newPage) => {
        handlerMoreData(newPage);
    };
    // 페이지 버튼 렌더링
    const renderPageButtons = () => {
        const buttons = [];
        for (let i = startPage; i < Math.min(startPage + pageSize, totalPages); i++) {
            buttons.push(react_1.default.createElement(Button_1.Button, { key: i, className: i === page ? 'active' : 'unactive', text: String(i + 1), onClick: () => handlePageChange(i) }));
        }
        return buttons;
    };
    if (totalPages <= 1)
        return null;
    return (react_1.default.createElement("div", { className: "flex row paging" },
        react_1.default.createElement(Button_1.Button, { className: `arrow ${canJumpFirst ? 'active' : 'unactive'}`, option: {
                buttonBeforeIcon: {
                    show: true,
                    name: 'twoarrow',
                    size: 24,
                    color: Colors_1.Colors.w_grey,
                },
            }, onClick: canJumpFirst ? () => handlePageChange(firstJumpTarget) : undefined }),
        react_1.default.createElement(Button_1.Button, { className: `arrow ${hasPrevPage ? 'active' : 'unactive'}`, option: {
                buttonBeforeIcon: {
                    show: true,
                    name: 'arrow',
                    size: 20,
                    color: Colors_1.Colors.w_grey,
                },
            }, onClick: hasPrevPage ? () => handlePageChange(page - 1) : undefined }),
        renderPageButtons(),
        react_1.default.createElement(Button_1.Button, { className: `arrow ${hasNextPage ? 'active' : 'unactive'}`, option: {
                buttonBeforeIcon: {
                    show: true,
                    className: 'arrow-right',
                    name: 'arrow',
                    size: 20,
                    color: Colors_1.Colors.w_grey,
                },
            }, onClick: hasNextPage ? () => handlePageChange(page + 1) : undefined }),
        react_1.default.createElement(Button_1.Button, { className: `arrow ${canJumpLast ? 'active' : 'unactive'}`, option: {
                buttonBeforeIcon: {
                    show: true,
                    className: 'arrow-right',
                    name: 'twoarrow',
                    size: 24,
                    color: Colors_1.Colors.w_grey,
                },
            }, onClick: canJumpLast ? () => handlePageChange(lastJumpTarget) : undefined })));
});
exports.default = Paging;
